import { useEffect, useRef, useState } from 'react';
import Cropper from 'cropperjs';
import { UseCropParams, UseCropResult } from './types';

export function useCrop(props: UseCropParams): UseCropResult {
  const image = useRef<HTMLImageElement>(null);
  const cropper = useRef<Cropper>();

  // 文件选择框选择的文件
  const [file, setFile] = useState<Blob>();

  useEffect(() => {
    // 包含img的modal未打开时，image的ref值为空
    if (image.current == null) {
      return;
    }

    if (file == null) {
      return;
    }

    // 设置图片并初始化裁剪器
    image.current.src = URL.createObjectURL(file);
    // 处理重新上传图片
    if (cropper.current != null) {
      cropper.current?.replace(image.current.src);
      return;
    }
    cropper.current = new Cropper(image.current, {
      aspectRatio: props.aspectRatio,
      background: false,
      ready(): void {
        cropper.current?.crop();
      }
    });
  }, [file, props.aspectRatio]);

  /**
   * 用给定的File，初始化裁剪器，
   * 注意需要在image被初始化之后再调用这个方法，也就是先显示裁剪用的modal，否则不会初始化裁剪器
   * @param File
   */
  function initCrop(file: Blob): void {
    setFile(file);
  }

  /**
   * 通过crop对象获取裁剪后的图片，并以File的形式返回
   * @returns
   */
  async function getCropImage(): Promise<Blob> {
    return await new Promise<Blob>((resolve, reject) => {
      cropper.current?.getCroppedCanvas()?.toBlob(blob => {
        if (blob != null) {
          return resolve(blob);
        }
        reject('clipping exception');
      }, file?.type ?? 'image/jpeg');
    });
  }

  return {
    image,
    initCrop,
    getCropImage
  };
}

